<template>
  <quill-editor :id="id" v-model="model" ref="myQuillEditor" :options="editorOption">
  </quill-editor>
</template>

<script>
import { quillEditor } from 'vue-quill-editor';
import axios from 'axios';
import * as Quill from 'quill';
var fonts = [
  'SimSun',
  'SimHei',
  'Microsoft-YaHei',
  'KaiTi',
  'FangSong',
  'Arial',
  'Times-New-Roman',
  'sans-serif'
];
var Font = Quill.import('formats/font');
Font.whitelist = fonts; // 将字体加入到白名单
Quill.register(Font, true);
export default {
  components: {
    quillEditor
  },
  props: {
    id: String,
    placeholder: String,
    disabled: Boolean,
    content: String,
    action: {
      default: '123123123',
      type: String
    }
  },
  data() {
    return {
      model: this.content,
      editorOption: {
        modules: {
          imageResize: {
            displayStyles: {
              backgroundColor: 'black',
              border: 'none',
              color: 'white'
            },
            modules: ['Resize', 'DisplaySize', 'Toolbar']
          },
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{ header: 1 }, { header: 2 }],
            [{ list: 'ordered' }, { list: 'bullet' }],
            // [{ script: 'sub' }, { script: 'super' }],
            [{ indent: '-1' }, { indent: '+1' }],
            [{ direction: 'rtl' }],
            [
              {
                size: [
                  '10px',
                  '12px',
                  '14px',
                  '16px',
                  '18px',
                  '20px',
                  '22px',
                  '24px',
                  '26px',
                  '32px'
                ]
              }
            ],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ font: fonts }],
            [{ color: [] }, { background: [] }],
            [{ align: [] }],
            ['clean'],
            ['link', 'image']
          ]
        },
        placeholder: '输入内容........'
      },
      editorToolbar: [
        ['bold', 'italic', 'underline', 'strike', 'image'],
        ['formula', 'clean'],
        ['blockquote', 'code-block'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ indent: '-1' }, { indent: '+1' }],
        [{ script: 'sub' }, { script: 'super' }],
        [
          {
            size: [
              '10px',
              '12px',
              '14px',
              '16px',
              '18px',
              '20px',
              '22px',
              '24px',
              '26px',
              '32px',
              '48px'
            ]
          }
        ],
        [{ font: [] }],
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        [{ color: [] }, { background: [] }],
        [{ align: [] }],
        [{ direction: 'rtl' }]
      ]
    };
  },
  methods: {
    imageAdded(file, Editor, cursorLocation, resetUploader) {
      var formData = new FormData();
      formData.append('file', file);
      axios({
        url: this.action,
        method: 'POST',
        data: formData
      })
        .then(result => {
          let url = result.data.data.path; // Get url from response
          Editor.insertEmbed(cursorLocation, 'image', url);
          resetUploader();
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  watch: {
    model(value, old) {
      this.$emit('update:content', this.model);
      if (value !== old) this.$emit('change');
    },
    content(value) {
      this.model = value;
    }
  }
};

/* 注1：vue2-editor是对Quill的封装，可使用editorOptions来注册quill的扩展module */
/* 注2：目前图片上传默认转换为base64编码存储，如需修改为上传到磁盘路径，可直接于本自定义组件中编写公共处理器，参考 https://github.com/davidroyer/vue2-editor */
</script>
<style lang="stylus">
.ql-editor {
  min-height 200px
}
</style>



// WEBPACK FOOTER //
// src/common/component/qeditor.vue